import React, { useState } from "react";
import { Form, Modal } from "react-bootstrap";
import { useAppSelector } from "../../store";
import CreateNewAgent from "../FlightEnquiryForm/CreateNewAgent";
import { TopMenuEnum } from "../Common/WidgetMenuHelper";
import HotelsQueryForm from "../Tabs/HotelsQueryForm";
import {
  ISelectedCustomer,
  SearchCustomerSelect,
} from "../Common/SearchCustomerSelect";
import { appAxios } from "../../axios/axios";
import { EnumUserType, IUserData } from "../../interfaces/userData.interface";
import { AxiosResponse } from "axios";
import { IResponse } from "../../interfaces/requestResponse.interface";

const FlightsForm = React.lazy(() => import("../Tabs/FlightsForm"));
const OtherEnquiry = React.lazy(() => import("../Tabs/OtherEnquiry"));
const VisaEnquiryTab = React.lazy(() => import("../Tabs/VisaEnquiryTab"));

const CreateEnquiryModal: React.FC<{
  showCreateEnquiry: boolean;
  onClose: () => void;
  onSave: () => void;
}> = (props) => {
  const { websiteMenu } = useAppSelector((store) => store.siteData);
  const [selectedCustomer, setSelectedCustomer] = useState<
    ISelectedCustomer | undefined
  >(undefined);
  const [selectedEnquiryType, setSelectedEnquiryType] = useState("");
  const [showDetailPendingUser, setShowDetailPendingUser] = useState(false);

  const [selectedB2CCustomer, setSelectedB2CCustomer] = useState(false);

  const [userSelectLoading, setUserSelectLoading] = useState(false);

  const getDefaultUserDetail = async (userType: EnumUserType) => {
    setUserSelectLoading(true);
    const defaultUserResult: AxiosResponse<IResponse<IUserData>> =
      await appAxios.post("/api/staff/getOrCreateDefaultB2BOrB2CUser", {
        userType,
      });
    if (defaultUserResult.data.success) {
      const userDetail = defaultUserResult.data.result;
      const phoneCode = parseInt(userDetail.phoneCode)
        ? userDetail.phoneCode
        : "";
      setSelectedCustomer({
        label: `${userDetail.firstName} ${userDetail.lastName}(${userDetail.email}) ${phoneCode} ${userDetail.phone}`,
        name: `${userDetail.firstName} ${userDetail.lastName}`,
        phone: phoneCode + " " + userDetail.phone,
        value: userDetail.uuid,
        user: userDetail,
      });
    }

    setUserSelectLoading(false);
  };

  return (
    <Modal
      centered
      size="xl"
      onHide={props.onClose}
      show={props.showCreateEnquiry}
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Create Enquiry
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="row">
          <div key={`default-checkbox`} className=" col-6 mb-3">
            <Form.Check
              className=""
              type={"checkbox"}
              name={`default-customer`}
              id={`default-checkbox-b2c`}
              checked={selectedB2CCustomer}
              label={`Default B2C`}
              onChange={(e) => {
                setSelectedB2CCustomer(e.target.checked);
                if (e.target.checked) {
                  getDefaultUserDetail("retail" as EnumUserType);
                }
              }}
            />
          </div>
          <div className="col-6 text-end small">
            <button
              type="button"
              className="btn btn-primary btn-sm px-3"
              onClick={() => setShowDetailPendingUser(true)}
            >
              Create User
            </button>
          </div>
          <div className="col-12 py-2">
            <div className="item-head">Search User</div>
            <SearchCustomerSelect
              value={selectedCustomer?.value}
              onChange={(e) => {
                if (!e) {
                  setSelectedCustomer(undefined);
                  return;
                }

                setSelectedCustomer(e);
              }}
              isDisabled={selectedB2CCustomer}
              isLoading={userSelectLoading}
            />
          </div>
          <div className="col-12 py-2">
            <div className="item-head">Enquiry Type</div>
            <Form.Select
              size="sm"
              onChange={(e) => {
                setSelectedEnquiryType(e.target.value);
              }}
              value={selectedEnquiryType}
              className="py-2"
            >
              <option value="" defaultChecked>
                select...
              </option>
              {websiteMenu.map((menu) => {
                let showOption =
                  menu.key === TopMenuEnum.flightsForm ||
                  menu.key === TopMenuEnum.hotels ||
                  menu.key === TopMenuEnum.visaEnquiry ||
                  menu.key === TopMenuEnum.otherEnquiry;

                if (showOption) {
                  return (
                    <option key={menu.key} value={menu.key}>
                      {menu.moduleName}
                    </option>
                  );
                }

                return undefined;
              })}
            </Form.Select>
          </div>
        </div>

        {showDetailPendingUser && (
          <CreateNewAgent
            isModalOpen={showDetailPendingUser}
            handleModalClose={() => {
              setShowDetailPendingUser(false);
            }}
            url="/query-management-staff/createDetailPendingCustomer"
          />
        )}

        <div className="App container" id="module">
          <div id="search-form">
            <div className="tab-content" id="search">
              {selectedCustomer && selectedEnquiryType === "FlightsForm" && (
                <FlightsForm
                  onSaveEnquiry={() => {
                    setSelectedCustomer(undefined);
                    setSelectedEnquiryType("");
                    props.onSave();
                  }}
                  onBehalfByStaff={true}
                  userData={selectedCustomer.user}
                />
              )}
              {selectedCustomer && selectedEnquiryType === "VisaEnquiry" && (
                <VisaEnquiryTab
                  onSaveEnquiry={() => {
                    setSelectedCustomer(undefined);
                    setSelectedEnquiryType("");
                    props.onSave();
                  }}
                  onBehalfByStaff={true}
                  userData={selectedCustomer.user}
                />
              )}
              {selectedCustomer && selectedEnquiryType === "OtherEnquiry" && (
                <OtherEnquiry
                  onSaveEnquiry={() => {
                    setSelectedCustomer(undefined);
                    setSelectedEnquiryType("");
                    props.onSave();
                  }}
                  onBehalfByStaff={true}
                  userData={selectedCustomer.user}
                />
              )}
              {selectedCustomer && selectedEnquiryType === "Hotels" && (
                <HotelsQueryForm
                  onSaveEnquiry={() => {
                    setSelectedCustomer(undefined);
                    setSelectedEnquiryType("");
                    props.onSave();
                  }}
                  onBehalfByStaff={true}
                  userData={selectedCustomer.user}
                />
              )}
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-secondary" onClick={() => props.onClose()}>
          Close
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default CreateEnquiryModal;
